import { render, staticRenderFns } from "./BrokerCompanies.vue?vue&type=template&id=147cf6ae&scoped=true&lang=pug"
import script from "./BrokerCompanies.vue?vue&type=script&lang=js"
export * from "./BrokerCompanies.vue?vue&type=script&lang=js"
import style0 from "./BrokerCompanies.vue?vue&type=style&index=0&id=147cf6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147cf6ae",
  null
  
)

export default component.exports